var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img_ind_box"},[_c('div',{staticClass:"img_ind ind_on1"},[_vm._v("图一")]),_c('div',{staticClass:"img_ind ind_on2"},[_vm._v("图二")]),_c('div',{staticClass:"img_ind ind_on3"},[_vm._v("图三")]),_c('div',{staticClass:"img_ind ind_on4"},[_vm._v("图四")])])
}]

export { render, staticRenderFns }